import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export type LogoutCallback = (resp?: AxiosResponse, err?: AxiosError) => void;

export const logout = (callback: LogoutCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/auth/logout", RemoteConfig.url);
	const result = client.post(url.toString(), null, {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		callback(resp)
	})
}
